// extracted by mini-css-extract-plugin
module.exports = {"list":"style_list__2sQFe","item":"style_item__31dt0","overlay":"style_overlay__Xvpcw","img":"style_img__3MWd0"};